// src/pages/Resources/ServiceIcons.tsx
import React from "react";
import { TeamInfo, PlannerPlan } from "@/types";
import "./ServiceIcons.scss";

interface ServiceIconsProps {
  team?: TeamInfo | null;
  plannerPlans?: PlannerPlan[] | null;
  siteUrl?: string | null;
}

const ServiceIcons: React.FC<ServiceIconsProps> = () => {
  return (
    <div className="service-icons d-inline-flex align-items-center gap-2" onClick={(e) => e.stopPropagation()}>
      {/* Teams Icon - Commented out: data comes from M365ObjectLinks (HAS_TEAM links) which may not be populated */}
      {/* <div className="service-icon-wrapper" style={{ position: "relative" }}>
        <img
          src={team ? "/Images/microsoft-teams.png" : "/Images/microsoft-teams-gray.png"}
          alt="Microsoft Teams"
          className={`service-icon teams ${team ? 'active' : 'disabled'}`}
          onClick={(e) => {
            e.stopPropagation();
            if (team) handleTeamClick();
          }}
          title={team ? "Go to Team" : "No Team"}
        />
      </div> */}

      {/* Planner Icon - Commented out: data comes from M365ObjectLinks (HAS_PLANNER_PLAN links) which may not be populated */}
      {/* <div className="service-icon-wrapper" style={{ position: "relative" }}>
        <img
          src={plannerPlans && plannerPlans.length > 0 ? "/Images/microsoft-planner.png" : "/Images/microsoft-planner-gray.png"}
          alt="Microsoft Planner"
          className={`service-icon planner ${plannerPlans && plannerPlans.length > 0 ? 'active' : 'disabled'}`}
          onClick={(e) => {
            if (plannerPlans && plannerPlans.length > 0) {
              handleSinglePlannerClick(e);
            }
          }}
          title={
            plannerPlans && plannerPlans.length > 0
              ? plannerPlans.length === 1 
                ? "Go to Plan" 
                : `${plannerPlans.length} Plans - Click to select`
              : "No Planner"
          }
        />
        {showPlannerDropdown && plannerPlans && plannerPlans.length > 1 && (
          <div
            className="planner-dropdown"
            onClick={(e) => e.stopPropagation()}
            onMouseLeave={() => setShowPlannerDropdown(false)}
          >
            {plannerPlans.map((plan) => (
              <div
                key={plan.id}
                className="planner-plan-item"
                onClick={(e) => {
                  e.stopPropagation();
                  const url = plan.webUrl || `https://planner.cloud.microsoft/webui/plan/${plan.id}`;
                  handlePlannerClick(url);
                }}
              >
                {plan.title}
              </div>
            ))}
          </div>
        )}
      </div> */}

      {/* SharePoint Icon - Commented out: data comes from M365ObjectLinks (HAS_SITE links) which may not be populated */}
      {/* <div className="service-icon-wrapper">
        <img
          src={siteUrl ? "/Images/microsoft-sharepoint.png" : "/Images/microsoft-sharepoint-gray.png"}
          alt="SharePoint"
          className={`service-icon sharepoint ${siteUrl ? 'active' : 'disabled'}`}
          onClick={(e) => {
            e.stopPropagation();
            if (siteUrl) {
              console.log("Opening SharePoint URL:", siteUrl);
              window.open(siteUrl, "_blank");
            }
          }}
          title={siteUrl ? "Go to Site" : "No SharePoint Site"}
        />
      </div> */}
    </div>
  );
};

export default ServiceIcons;
